import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { LanternCoreUtilsModule } from "../../core/utils/utils.module";
import { LanternUtilsModule } from "../utils";

import { ButtonGroupModule } from "./button-group";
import { CheckboxModule } from "./checkbox";
import { DatePickerModule } from "./datepicker";
import { FileDropDirectiveModule } from "./file-drop";
import { RadioModule } from "./radio";
import { SelectModule } from "./select";
import { TextareaComponentModule } from "./textarea";

@NgModule({
  imports: [
    ButtonGroupModule,
    CommonModule,
    FormsModule,
    LanternUtilsModule,
    LanternCoreUtilsModule
  ],
  exports: [
    ButtonGroupModule,
    DatePickerModule,
    FileDropDirectiveModule,
    FormsModule,
    SelectModule,
    CheckboxModule,
    RadioModule,
    TextareaComponentModule
  ]
})
export class LanternFormsModule {}
